var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"list list--definition list--clean"},[_vm._l((_vm.data),function(item){return [_c('dt',{key:`dt-${item.key}`},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('dd',{key:`dd-${item.key}`},[_vm._v(_vm._s(item.value))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }